
const digest = '563734f27dc593f107b4ad7401ed40ff98737f5bb665975fe41fca30b4f7d0ed';
const classes = {"wrapper":"_wrapper_wqcdi_1","content":"_content_wqcdi_7","title":"_title_wqcdi_13","status":"_status_wqcdi_18","open":"_open_wqcdi_32","closed":"_closed_wqcdi_35","controls":"_controls_wqcdi_38","arrow":"_arrow_wqcdi_38"};
const css = `._wrapper_wqcdi_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 18px;
  display: flex;
}
._wrapper_wqcdi_1 ._content_wqcdi_7 {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._wrapper_wqcdi_1 ._content_wqcdi_7 ._title_wqcdi_13 {
  font-weight: 600;
  font-size: 16px;
  color: #3c3f9c;
}
._wrapper_wqcdi_1 ._content_wqcdi_7 ._status_wqcdi_18 {
  font-size: 14px;
  color: #212357;
  display: flex;
  align-items: center;
  gap: 5px;
}
._wrapper_wqcdi_1 ._content_wqcdi_7 ._status_wqcdi_18::before {
  content: "";
  height: 5px;
  width: 5px;
  display: block;
  border-radius: 100%;
}
._wrapper_wqcdi_1 ._content_wqcdi_7 ._status_wqcdi_18._open_wqcdi_32::before {
  background: green;
}
._wrapper_wqcdi_1 ._content_wqcdi_7 ._status_wqcdi_18._closed_wqcdi_35::before {
  background: red;
}
._wrapper_wqcdi_1 ._controls_wqcdi_38 ._arrow_wqcdi_38 {
  height: 50px;
  width: 50px;
  min-width: 50px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(229, 243, 255);
  background: linear-gradient(0deg, rgb(229, 243, 255) 0%, rgb(244, 250, 255) 100%);
  color: #3c3f9c;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  